
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar } from '@/components/navbar';
import { Button } from '@/components/ui/button';

const BusinessNotFound: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-brand-light flex flex-col">
      <NavBar />
      <main className="flex-1 max-w-screen-xl mx-auto px-4 md:px-8 py-8">
        <div className="text-center">
          <h1 className="text-2xl font-semibold mb-4">Business Not Found</h1>
          <Button onClick={() => navigate('/')}>Back to My Businesses</Button>
        </div>
      </main>
    </div>
  );
};

export default BusinessNotFound;
